import { onBeforeUnmount, ref, watch } from "vue";
import { useRouter } from "vue-router";
const DOCUMENT_CHANNEL = "pa-workspace-documents";
const TAB_ID = crypto.randomUUID();
/** The channel a workspace tab and its own documents window talk on. */
export function documentChannelName(tabId) {
    return `${DOCUMENT_CHANNEL}:${tabId}`;
}
/** Pops the document viewer into its own window and keeps it on the PA the workspace has open. */
export function useDocumentWindow(orderKey, label, onClosed) {
    const router = useRouter();
    const open = ref(false);
    let channel = null;
    let popup = null;
    let closedPoll;
    function announce() {
        if (orderKey.value)
            channel?.postMessage({
                type: "order",
                orderKey: orderKey.value,
                label: label.value,
            });
    }
    function markClosed() {
        if (!open.value)
            return;
        open.value = false;
        clearInterval(closedPoll);
        popup = null;
        onClosed();
    }
    function ensureChannel() {
        if (channel)
            return;
        channel = new BroadcastChannel(documentChannelName(TAB_ID));
        channel.onmessage = (event) => {
            if (event.data.type === "ready")
                announce();
            if (event.data.type === "closed" && (!popup || popup.closed))
                markClosed();
        };
    }
    function popOut() {
        if (!orderKey.value)
            return false;
        ensureChannel();
        const url = router.resolve({ name: "pa-documents", params: { id: orderKey.value }, query: { tab: TAB_ID } }).href;
        const width = Math.min(980, Math.round(window.screen.availWidth * 0.5));
        const height = Math.round(window.screen.availHeight * 0.9);
        popup = window.open(url, `${DOCUMENT_CHANNEL}-${TAB_ID}`, `popup,width=${width},height=${height}`);
        if (!popup)
            return false;
        open.value = true;
        clearInterval(closedPoll);
        closedPoll = setInterval(() => popup?.closed && markClosed(), 1000);
        return true;
    }
    function dock() {
        channel?.postMessage({ type: "dock" });
        popup?.close();
        markClosed();
    }
    watch([orderKey, label], () => open.value && announce());
    onBeforeUnmount(() => {
        clearInterval(closedPoll);
        channel?.postMessage({ type: "dock" });
        popup?.close();
        channel?.close();
    });
    return { open, popOut, dock };
}
